export const LOAD_CAPTCHA = "@CAPTCHA/LOAD_CAPTCHA";
export const LOAD_CAPTCHA_DONE = "@CAPTCHA/LOAD_CAPTCHA_DONE";
